import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import './Header.css';

/// ヘッダーコンポーネント - サイトの上部ナビゲーション
const Header: React.FC = () => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  /// アクティブリンクの判定
  const isActiveLink = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <img 
            src="/assets/images/icon/marle_icon.jpg" 
            alt="マール・アストレア アイコン" 
            className="logo-image"
            onError={(e) => {
              // アイコン画像が見つからない場合のフォールバック
              e.currentTarget.src = '/assets/images/icon/marle_icon.jpg';
            }}
          />
          <h1 className="site-title">
            <span className="title-main">マール・アストレア</span>
            <span className="title-sub">非公式ファンサイト</span>
          </h1>
        </div>
        
        <div className="header-right">
          <nav className="header-nav">
            <ul className="nav-list">
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={`nav-link ${isActiveLink('/') ? 'active' : ''}`}
                >
                  ホーム
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/search" 
                  className={`nav-link ${isActiveLink('/search') ? 'active' : ''}`}
                >
                  検索
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/watch-together" 
                  className={`nav-link ${isActiveLink('/watch-together') ? 'active' : ''}`}
                >
                  みんなで視聴
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/links" 
                  className={`nav-link ${isActiveLink('/links') ? 'active' : ''}`}
                >
                  リンク集
                </Link>
              </li>
            </ul>
          </nav>
          <button
            className="theme-toggle-button"
            onClick={toggleTheme}
            aria-label={theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'}
            title={theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'}
          >
            {theme === 'light' ? (
              <span className="theme-icon">🌙</span>
            ) : (
              <span className="theme-icon">☀️</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 